<template>
  <div class="login-bg">
    <div class="login-box">
      <div class="login-box-left">
        <img :src="loginLog" alt="">
        <h2>客户平台登录</h2>
        <div class="login-form">
          <ul :style="{ 'marginBottom': tabCtrl == 'qrcode' ? '0px' : '' }">
            <!-- <li @click="tabCtrl='mobilephone'" :class="[tabCtrl=='mobilephone'?'active':'']">手机验证码</li> -->
            <li :class="[tabCtrl == 'account' ? 'active' : '']" @click="tabCtrl = 'account'">账号密码</li>
            <!-- <li @click="getQrCode()" :class="[tabCtrl=='qrcode'?'active':'']">二维码</li> -->
          </ul>
          <div v-show="tabCtrl == 'mobilephone'" class="mobilephone">
            <div class="input-box">
              <input v-model.trim="mobile" type="text" placeholder="请输入手机号">
              <span class="icon icon-phone-01"></span>
            </div>
            <div class="input-box">
              <input v-model.trim="smCode" type="text" placeholder="请输入验证码">
              <span class="icon icon-password-01"></span>
              <span
                v-if="!sendCodeCtrl" id="TencentCaptcha" class="text send-verification-code"
                @click="sendCode()"
              >发送验证码</span>
              <span v-if="sendCodeCtrl" class="text resend">重新发送（{{ second }}S）</span>
            </div>
          </div>
          <div v-show="tabCtrl == 'account'" class="accout-password">
            <div class="input-box">
              <input v-model.trim="userName" type="text" placeholder="请输入账号">
              <span class="icon icon-user-01"></span>
            </div>
            <div class="input-box">
              <input v-model.trim="password" type="password" placeholder="请输入密码">
              <span class="icon icon-password-01"></span>
            </div>
            <div class="input-forget"><a href="/#/resetPassword">忘记密码？</a></div>
          </div>
          <div v-show="tabCtrl == 'qrcode'" class="qrcode-box">
            <div v-show="!wechatError" id="login_container"></div>
            <div v-show="wechatError" class="wechat-error">
              获取微信二维码失败
            </div>
          </div>
          <Button
            v-show="tabCtrl != 'qrcode'" class="login-btn" type="primary"
            :disabled="(mobile && smCode || userName && password) ? false : true"
            @click="handleSubmit()"
          >
            登&nbsp;&nbsp;录
          </Button>
        </div>
        <!-- <p class="register">没有账号？<a href="/#/register">立即注册</a></p> -->
      </div>
      <div class="login-box-right"></div>
    </div>
    <Message ref="message" :message="message" :icon-type="'error'" />
  </div>
</template>
<script>
import Message from '@/components/common/message/message'
export default {
  components: {
    Message
  },
  props: [''],
  data() {
    return {
      tabCtrl: 'account',
      loginLog: require('../../assets/images/login-logo.png'),
      second: 59,
      sendCodeCtrl: false,
      mobile: '',
      smCode: '',
      userName: '',
      password: '',
      message: '',
      wechatError: false
    }
  },
  computed: {

  },
  watch: {
    tabCtrl(val, oldVal) {
      if (val == 'mobilephone') {
        this.userName = ''
        this.password = ''
      } else if (val == 'account') {
        this.mobile = ''
        this.smCode = ''
      }
    },
    $route(val, oldVal) {
      if (val.fullPath.indexOf('?') != -1) {
        console.log(val.query)
        this.code = val.query.code
        this.state = val.query.state
        this.getAccessToken()
      }
    }
  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    window.localStorage.setItem('token', '')
    window.localStorage.setItem('refreshToken', '')
    window.localStorage.setItem('expiryTime', '')
    window.localStorage.setItem('account', '')
    window.localStorage.setItem('currentUser', '')
    // this.getQrCode();
    // 回车事件
    document.addEventListener('keydown', this.keydownEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydownEvent)// 移除监听事件的回调函数
  },
  updated() {

  },
  methods: {
    handleSubmit() {
      console.log(this.tabCtrl)
      let url, ajaxData
      if (this.tabCtrl == 'mobilephone') {
        if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$Message.error('手机号码有误，请重填')
          return false
        }
        url = '/authentication/auth/loginMobile'
        ajaxData = {
          grantType: 'password',
          mobile: this.mobile,
          smsCode: this.smCode
        }
      } else if (this.tabCtrl == 'account') {
        url = '/authentication/auth/login'
        ajaxData = {
          grantType: 'password',
          userName: this.userName,
          password: this.password
        }
      }
      console.log(ajaxData)
      this.$post(url, ajaxData).then(res => {
        console.log(res)
        if (res.code == 0) {
          window.localStorage.setItem('token', res.data.accessToken)
          window.localStorage.setItem('refreshToken', res.data.refreshToken)
          window.localStorage.setItem('expiryTime', new Date().getTime())
          window.localStorage.setItem('account', JSON.stringify(res.data.additionalInformation.account))
          window.localStorage.setItem('currentUser', JSON.stringify(res.data.additionalInformation.currentUser))

          if (!res.data.additionalInformation.isPerfectUser) {
            this.getCustomerDetail()
          } else {
            this.getCustomerDetail()
          }
        } else if (res.code === 10007) {
          window.localStorage.setItem('token', res.data.accessToken)
          window.localStorage.setItem('refreshToken', res.data.refreshToken)
          window.localStorage.setItem('expiryTime', new Date().getTime())
          window.localStorage.setItem('account', JSON.stringify(res.data.additionalInformation.account))
          window.localStorage.setItem('currentUser', JSON.stringify(res.data.additionalInformation.currentUser))
          // 重新修改信息  获取自己信息的接口  驳回原因
          this.$Message.warning({
            content: res.message,
            duration: 5,
            closable: true
          })
          this.$router.push({ path: './personalCenter/information' })
          // this.$Message.warning(res.message);
          // this.$router.push({path:'./personalCenter/information'});
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    async getCustomerDetail() {
      const url = '/base/customer-member/my'
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          localStorage.setItem('custType', res.data.type)
          res.data.type == 'C' ? this.$router.push({ path: '/channel' }) : this.$router.push({ path: '/' })
        }
      })
    },
    sendCode() {
      if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
        this.$Message.error('手机号码有误，请重填')
        return false
      }
      const _this = this
      const url = '/base/verify/getImageVerifyConfig'
      this.$get(url).then(res => {
        // 先验证图形码
        const captcha = new TencentCaptcha(res.data.appId + '', function (res) {
          console.log(res)
          _this.getSmCode(res.ticket, res.randstr)
        })
        captcha.show()
        document.getElementById('t_mask').style.background = '#fff'
      })
    },
    getSmCode(ticket, randstr) {
      // 假装获取验证码
      const url = '/base/sms/getSmsCode?mobile=' + this.mobile + '&ticket=' + ticket + '&randStr=' + randstr
      this.$get(url).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.sendCodeCtrl = true
          this.second = 59
          let timeId = null
          timeId = setInterval(() => {
            this.second--
            if (this.second < 0) {
              clearInterval(timeId)
              this.sendCodeCtrl = false
            }
          }, 1000)
        } else {
          this.message = res.message
          this.$refs.message.show()
        }
      })
    },
    getQrCode() {
      this.tabCtrl = 'qrcode'
      document.getElementById('login_container').innerHTML = ''
      const url = '/wechat/open/js-api-config'
      this.$get(url).then(res => {
        if (res.code == 0) {
          var obj = new WxLogin({
            id: 'login_container',
            appid: res.data.appId,
            scope: res.data.scope,
            redirect_uri: encodeURIComponent(this.config.basePath + '/#/login'),
            state: res.data.state,
            style: '',
            href: './login.css'
          })
          document.getElementsByTagName('iframe')[0].style.height = '345px'
        } else {
          this.wechatError = true
        }
      }).catch(err => {
        this.wechatError = true
      })
    },
    getUnionId() {
      const _this = this
      const url = '/openwechat/wechatProxy/getWechatUserInfo?code=' + this.code + '&state=' + this.state
      console.log(url)
      return new Promise(function (resolve, reject) {
        _this.$get(url).then(res => {
          console.log(res)
          if (res.code == 0) {
            resolve(res.data.unionId)
          } else {
            reject(res.code)
          }
        })
      })
    },
    keydownEvent: function (e) {
      // 兼容FF和IE和Opera
      var theEvent = window.event || e
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode
      if (code == 13) {
        this.handleSubmit()
      }
    },
    async getAccessToken() {
      const unionId = await this.getUnionId()
      console.log(unionId)
      const url = '/authentication/auth/loginWechat'
      const ajaxData = {
        unionId: unionId,
        providerId: 'wechat',
        grantType: 'password'
      }
      this.$post(url, ajaxData).then(res => {
        if (res.code == 0) {
          window.localStorage.setItem('token', res.data.accessToken)
          window.localStorage.setItem('refreshToken', res.data.refreshToken)
          window.localStorage.setItem('expiryTime', new Date().getTime())
          window.localStorage.setItem('account', JSON.stringify(res.data.additionalInformation.account))
          this.$router.push({ path: '/' })
        } else if (res.code == 10005) {
          this.$router.push({ path: '/bindMobile', query: { unionId: unionId }})
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
@import "login.scss"
</style>




// WEBPACK FOOTER //
// src/view/login/login.vue